import { useEffect, useState } from 'react'
import { latestEntry, runningEntry } from './latest-entry'

const CHECK_EVERY_MS = 5 * 60_000
const MIN_GAP_MS = 60_000

/**
 * True once the server ships a different build than the one running. Checks when the tab comes back into
 * view or the device reconnects, and every few minutes while visible; never more than once a minute.
 */
export function useNewVersion(): boolean {
  const [available, setAvailable] = useState(false)

  useEffect(() => {
    const running = runningEntry()
    if (!running || available) return
    let last = 0
    let alive = true
    const check = async () => {
      if (document.visibilityState !== 'visible' || Date.now() - last < MIN_GAP_MS) return
      last = Date.now()
      const latest = await latestEntry().catch(() => null)
      if (alive && latest && latest !== running) setAvailable(true)
    }
    const onWake = () => void check()
    const timer = window.setInterval(onWake, CHECK_EVERY_MS)
    document.addEventListener('visibilitychange', onWake)
    window.addEventListener('focus', onWake)
    window.addEventListener('online', onWake)
    return () => {
      alive = false
      window.clearInterval(timer)
      document.removeEventListener('visibilitychange', onWake)
      window.removeEventListener('focus', onWake)
      window.removeEventListener('online', onWake)
    }
  }, [available])

  return available
}
